import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { FiMenu, FiX, FiUsers, FiSettings, FiHome, FiDroplet, FiShield, FiGrid, FiTool } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { AdminGuard, FranchiseeGuard, OperatorGuard } from '../auth/PermissionGuard';
import './DashboardLayout.css';

const DashboardLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { userProfile, signOut } = useAuth();

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="dashboard-container">
      <div className="mobile-header">
        <button onClick={toggleSidebar} className="sidebar-toggle-btn">
          {isSidebarOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>
      <aside className={`dashboard-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <Link to="/dashboard/block-management" className="sidebar-brand" onClick={() => setSidebarOpen(false)}>
          <img 
            src="/black_icon_only.png" 
            alt="Block Logo" 
            className="sidebar-logo"
          />
          <span>block automation</span>
        </Link>
        <nav className="sidebar-nav">
          {/* Core Navigation - Available to all authenticated users */}
          <div className="nav-section">
            <div className="nav-section-title">Block Operations</div>
            
            <Link to="/dashboard/block-management" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
              <FiHome className="sidebar-icon" />
              Block Management
            </Link>

            <AdminGuard>
              <Link to="/dashboard/block-setup" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiSettings className="sidebar-icon" />
                Block Setup
              </Link>
            </AdminGuard>
          </div>

          {/* Franchisee and Admin Navigation */}
          <FranchiseeGuard>
            <div className="nav-section">
              <div className="nav-section-title">Management</div>
              
              <Link to="/dashboard/sunscreen-management" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiDroplet className="sidebar-icon" />
                Sunscreen Management
              </Link>
              
              <Link to="/dashboard/franchise-management" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiShield className="sidebar-icon" />
                Franchise Management
              </Link>

              <Link to="/dashboard/settings" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiSettings className="sidebar-icon" />
                Settings
              </Link>
            </div>
          </FranchiseeGuard>

          {/* Admin-only Navigation */}
          <AdminGuard>
            <div className="nav-section">
              <div className="nav-section-title">Administration</div>
              
              <Link to="/dashboard/admin-setup" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiShield className="sidebar-icon" />
                Admin Setup
              </Link>
              
              <Link to="/dashboard/user-management" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiUsers className="sidebar-icon" />
                User Management
              </Link>

              <Link to="/dashboard/franchisee-management" className="sidebar-link" onClick={() => setSidebarOpen(false)}>
                <FiGrid className="sidebar-icon" />
                Franchisee Management
              </Link>
            </div>
          </AdminGuard>
        </nav>

        {/* User Profile Section */}
        <div className="sidebar-footer">
          <div className="user-profile">
            <div className="user-avatar">
              {userProfile?.displayName?.charAt(0) || userProfile?.email?.charAt(0) || '?'}
            </div>
            <div className="user-info">
              <div className="user-name">{userProfile?.displayName || 'User'}</div>
              <div className="user-role">{userProfile?.globalRole || 'Loading...'}</div>
            </div>
          </div>
          <button onClick={handleSignOut} className="sign-out-btn">
            Sign Out
          </button>
        </div>
      </aside>
      <main className="dashboard-main">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;